// CornestoneTest.js
export default {
  name: 'CornerstoneTest',
  data() {
    return {
      maxFrames: 0, // Total de frames disponibles
      currentFrame: 0, // Frame actual
    };
  },
  mounted() {
    run.bind(this)();
  }
}

import {
  Enums,
  RenderingEngine,
  setVolumesForViewports,
  volumeLoader,
  eventTarget,
  utilities
} from '@cornerstonejs/core';

import initCornerstone from "/src/helpers/initCornerstone";

//import { api } from 'dicomweb-client';

import * as cornerstoneTools from '@cornerstonejs/tools';

import * as aux_cornestone from "@/helpers/cornestone_fun_aux";

import * as aux_api from "@/helpers/api_fun_aux";

import { showAlert } from "@/helpers/alerts";

//import segmentMapJson from '/src/helpers/classes.json';

//import * as cornerstoneDICOMImageLoader from '@cornerstonejs/dicom-image-loader';
//import * as cornerstone from '@cornerstonejs/core';

//Inicialize all parameters

const {
ToolGroupManager,
PanTool,
StackScrollMouseWheelTool,
CrosshairsTool,
ZoomTool,
PlanarFreehandROITool,
RectangleROITool,
ArrowAnnotateTool,
SculptorTool,
Enums: csToolsEnums,
} = cornerstoneTools;


const { MouseBindings } = csToolsEnums;

const { ViewportType } = Enums;

// Use to manage the text indicator of loading image
let loadingInterval

//Params read from the url
const rmv_code = aux_cornestone.getQueryParam('code');
const token = aux_cornestone.getQueryParam('token');

if (process.env.VUE_APP_DEBUG === "true") {
  console.log("Código recibido:", rmv_code);
  console.log("Token recibido:", token);
}

//Class/Segment active to visualize
let activeSegmentIndex = 1;

//All the classes are visible
let all = true;

// Show annotation textBox
let show_textbox = true;

//The volume is loaded
let volLoaded = false;

//Main function
export async function run() {

  let segmentMapJsonLoaded =null;
  //Call api to get json file with all anotattion classes
  try {
    const url_api = process.env.VUE_APP_API_URL + "/viewer";
    const api_url_endpoint_annotation_classes = url_api + "/nn-annotation-classes";

      const response = await fetch(api_url_endpoint_annotation_classes, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });    

    if (!response.ok) {
      console.log(`Error fetching get annotation classes file: ${response.status}`);

      if (response.status === 401) {
        console.log(`Unauthorized user: ${response.status}`);
        window.location.replace(process.env.VUE_APP_WEBAPP_URL + "/account/login");
        return;
      } else {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
    }
    const segmentMap = await response.json();
    segmentMapJsonLoaded = new Map(Object.entries(segmentMap));
    console.log('Annotation classes loaded:', segmentMapJsonLoaded);

  } catch (error) {
    console.error('Error loading annotation classes:', error);
    showAlert('error', 'Could not load annotation classes.');
  }
  // Load classes from JSON file and create Map
  // Variables que construiremos automáticamente:
  const segmentMapJsonn = new Map();         // name → id
  const classMapAllAttributtes = new Map();   //name -> { id, color }
  const annotationsJson = [];               // ID-indexed array of annotation groups
  const stylesJson = [];                    // ID-indexed array of styles

  // Construcción dinámica
  for (const [name, data] of segmentMapJsonLoaded.entries()) {
    const id = data.id;
    const style = data.style;

    // Map básico para el dropdown
    segmentMapJsonn.set(name, id);

    classMapAllAttributtes.set(name, {
      id,
      color: style.color, // Puedes añadir más: colorSelected, etc.
    });

    // Creamos y ubicamos el grupo de anotaciones por ID
    annotationsJson[id-1] = new cornerstoneTools.annotation.AnnotationGroup();

    // Asignamos estilo por ID
    stylesJson[id-1] = style;
  }

  // Update width annotation contour
  const style = cornerstoneTools.annotation.config.style.getDefaultToolStyles();
  style.global.lineWidth = 2; // Aumenta el grosor de todas las anotaciones
  cornerstoneTools.annotation.config.style.setDefaultToolStyles(style);
  
  console.log("JSON MAP");
  console.log(segmentMapJsonn)
  console.log(stylesJson)
  //Add test id to the interface
  const testDiv = document.getElementById('test-info');
  if (testDiv) {
    testDiv.textContent = `Test ID: ${rmv_code}`;
  }

  //Add Dropdown to select the annotation class
  // Transform the Map into an array with the class options (['Liver', 1],['Aorta', 2],['IVC', 3])
  // aux_cornestone.addDropdownToToolbarAnnotationClasses({
  //   labelText: 'Annotation Class ',
  //   options: {
  //     map: segmentMapJsonn, // Variable Map
  //     defaultValue: 1, // Default value
  //   },
  //   container: document.getElementById('toolbox'),
  //   onSelectedValueChange: (value) => {
  //     // Logic when the user selects an option
  //     activeSegmentIndex = value;

  //     console.log(`Segmento Activo: ${activeSegmentIndex}`);
  
  //     // Updates visible annotations
  //     aux_cornestone.updateActiveAnnotation(all, annotationsJson, activeSegmentIndex);
  //   },
  // });

aux_cornestone.addDropdownToToolbarAnnotationClasses({
  labelText: 'Annotation Class ',
  options: {
    map: classMapAllAttributtes,
    defaultValue: 1,
  },
  container: document.getElementById('toolbox'),
  onSelectedValueChange: (value, name, color) => {
    activeSegmentIndex = value;
    console.log(`Segmento Activo: ${value} (${name}) - color: ${color}`);

    aux_cornestone.updateActiveAnnotation(all, annotationsJson, activeSegmentIndex);
  },
});

  //Tool avaliables to do annotations
  const toolsNames = [
    PlanarFreehandROITool.toolName,
    SculptorTool.toolName,
    CrosshairsTool.toolName,
    RectangleROITool.toolName,
    ArrowAnnotateTool.toolName
  ];

  //Default annotation PlanarFreehandROITool
  let selectedToolName = toolsNames[0];

  //Add dropdown to select the annotation tool  
  aux_cornestone.addDropdownToToolbarAnnotationTool({
    options: { values: toolsNames, defaultValue: selectedToolName },
    onSelectedValueChange: (newSelectedToolNameAsStringOrNumber) => {
      const newSelectedToolName = String(newSelectedToolNameAsStringOrNumber);
      const toolGroup = ToolGroupManager.getToolGroup(toolGroupId);
  
      // Set the old tool passive
      toolGroup.setToolPassive(selectedToolName);

      // Set the new tool active
      toolGroup.setToolActive(newSelectedToolName, {
        bindings: [
          {
            mouseButton: MouseBindings.Primary, // Left Click
          },
        ],
      });
  
      selectedToolName = newSelectedToolName;
    },
  });


  //Set up show all layers button
  aux_cornestone.initializeButtonWithTooltip({
    containerId: 'button-showall-container',
    buttonId: 'show_all',
    tooltipId: 'tooltip-showall',
    tooltipText: 'Show selected class or display all annotation classes.',
    onClick: () => {
      all = !all;
      console.log("Show all button click");

      aux_cornestone.updateActiveAnnotation(all, annotationsJson, activeSegmentIndex);
    }
  });
  
  //Set up delete button
  aux_cornestone.initializeButtonWithTooltip({
    containerId: 'button-delete-container',
    buttonId: 'delete',
    tooltipId: 'tooltip-delete',
    tooltipText: 'Select an annotation. Then click this button to delete it.',
    onClick: () => {
      var an = cornerstoneTools.annotation.state.getAnnotation(cornerstoneTools.annotation.selection.getAnnotationsSelected()[0]);
      for (let i = 0; i < annotationsJson.length; i++) {
        annotationsJson[i].remove(an.annotationUID);
      }
      cornerstoneTools.annotation.state.removeAnnotation(cornerstoneTools.annotation.selection.getAnnotationsSelected()[0]);
    }
  });

  //Set up shiw textbox button
  aux_cornestone.initializeButtonWithTooltip({
    containerId: 'button-showtextbox-container',
    buttonId: 'show_textbox',
    tooltipId: 'tooltip-showtextbox',
    tooltipText: 'Show annotation data or display only annotation contour.',
    onClick: () => {
      console.log("Show textbox button click");
      show_textbox = !show_textbox;

      aux_cornestone.updateTextBoxView(show_textbox, cornerstoneTools);
      
    }
  });



  //Initiate Cornerstone
  await initCornerstone();

  //Create ImageIds and cache metadata
  //var a = "1.3.6.1.4.1.14519.5.2.1.7009.2403.334240657131972136850343327463";
  //var b = "1.3.6.1.4.1.14519.5.2.1.7009.2403.226151125820845824875394858561";
  //var c = "https://d3t6nz73ql33tx.cloudfront.net/dicomweb";
  //var a = "1";
  //var b = "1";
  //var c = "http://127.0.0.1:5007";
  //var imageIds = await createImageIds({StudyInstanceUID: a, SeriesInstanceUID: b, wadoRsRoot: c});

  // Show text indicating the dicom image is loading
  loadingInterval = aux_cornestone.showLoadingIndicator();

  // metaData.addProvider((type, imageId) => {
  //   const data = metaData.get(imageId);
  //   if (data) {
  //     return data[type];
  //   }
  // }, 100);

  // // Registrar el custom loader solo una vez
  // cornerstone.imageLoader.registerImageLoader('dicomzip', async function (imageId) {
  //   const id = imageId.replace('dicomzip:', '');
  //   const dicomFile = window.dicomFileMap[id];
  //   if (!dicomFile) {
  //     throw new Error(`No DICOM file found for id ${id}`);
  //   }

  //   const image = await cornerstone.wasm.imageLoader.decodeImage(dicomFile);
  //   return image;
  // });

  // var imageIds = await aux_api.getZipImageDicom(token, rmv_code);

  /** PRUEBAS DICOM FROM ZIP */

  //cornerstoneDICOMImageLoader.external.cornerstone = cornerstone;
  //cornerstoneDICOMImageLoader.configure();

  /** FIN PRUEBAS DICOM FROM ZIP */


  var imageIds = await aux_api.createImageIds(token, rmv_code);

  const volumeId = 'cornerstoneStreamingImageVolume: myVolume';

  const volume = await volumeLoader.createAndCacheVolume(volumeId, {imageIds});

  // Hide text indicating the dicom image is loading
  aux_cornestone.hideLoadingIndicator(loadingInterval);

  const toolGroupId = '1_TOOL_GROUP_ID';

  const toolGroup = setupCornerstoneTools(toolGroupId, volumeId);


  //EVENTO POR EL QUE ENTRA LA ANOTACION
  const auxprint = (event) => {
    console.log("TODAS LAS ANOTACIONES ACTIVAS:");

    cornerstoneTools.annotation.config.style.setAnnotationStyles(event.detail.annotation.annotationUID, stylesJson[activeSegmentIndex-1]);
    //console.table(event.detail.annotation);

    annotationsJson[activeSegmentIndex-1].add(event.detail.annotation.annotationUID);
    console.log(cornerstoneTools.annotation.state.getAnnotationManager().getAnnotations(volume.metadata.FrameOfReferenceUID));

  };

  eventTarget.addEventListener(
    csToolsEnums.Events.ANNOTATION_COMPLETED,
    auxprint
  );

  //Create html elements for viewports
  //Function to initialize the viewports
  const { elementAX, elementSA, elementCO } = setupViewportGrid(annotationsJson);

  // This engine manages multiple viewports and handles the rendering of medical images
  const renderingEngineId = 'myRenderingEngine';
  const renderingEngine = new RenderingEngine(renderingEngineId);

  // Viewport IDs
  const viewportIdAX = 'CT_AXIAL';
  const viewportIdSA = 'CT_SAGITTAL';
  const viewportIdCO = 'CT_CORONAL';

  // Viewport colors
  const viewportColors = {
    [viewportIdAX]: 'rgb(200, 0, 0)',
    [viewportIdSA]: 'rgb(200, 200, 0)',
    [viewportIdCO]: 'rgb(0, 200, 0)',
  };

  // Function to inicialize viewports
  const { viewAX } = initializeViewports(renderingEngine, toolGroup, renderingEngineId, viewportIdAX, viewportIdSA, viewportIdCO, elementAX, elementSA, elementCO);

  // Load the volume into memory before rendering
  await volume.load();

  setVolumesForViewports(
      renderingEngine,
      [{ volumeId }],
      [viewportIdAX, viewportIdSA, viewportIdCO]
  ).then(function() {volLoaded = true;});

  const input = document.getElementById('frame');
  const buttonprev = document.getElementById('prev');

  buttonprev.onclick = () => {
    cornerstoneTools.utilities.scroll(viewAX, {delta:-1});
  };

  const buttonnext = document.getElementById('next');

  buttonnext.onclick = () => {
    cornerstoneTools.utilities.scroll(viewAX, {delta:1});
  };

  //Set up Go to frame button
  aux_cornestone.initializeButtonWithTooltip({
    containerId: 'button-goFrame-container',
    buttonId: 'go',
    tooltipId: 'tooltip-goFrame',
    tooltipText: 'Go to the desired frame.',
    onClick: () => {
      if (process.env.VUE_APP_DEBUG === "true") {
        console.log("click go");
      }
      const del = input.value - utilities.getVolumeViewportScrollInfo(viewAX, volumeId, false).currentStepIndex;
      cornerstoneTools.utilities.scroll(viewAX, {delta:del});
    }
  });

  //Set up save annotattion button
  aux_cornestone.initializeButtonWithTooltip({
    containerId: 'button-save-container',
    buttonId: 'saveAnnotations',
    tooltipId: 'tooltip-save',
    tooltipText: 'Save annotations',
    onClick: (btn) => {
      if (process.env.VUE_APP_DEBUG === "true") {
        console.log("Save Annotation click");
      }
  
      aux_api.saveData(viewAX, annotationsJson, cornerstoneTools, stylesJson, rmv_code, token, segmentMapJsonLoaded, btn);
    }
  });

  //Set up load annotattion button
  aux_cornestone.initializeButtonWithTooltip({
    containerId: 'button-download-container',
    buttonId: 'loadAnnotations',
    tooltipId: 'tooltip-download',
    tooltipText: 'Load annotations last version.',
    onClick: () => {
      if (process.env.VUE_APP_DEBUG === "true") {
        console.log("Load Annotation click");
      }
  
      aux_api.loadData(viewAX, annotationsJson, cornerstoneTools, stylesJson);
    }
  });


  /**
  * Updates the input field with the current frame index based on viewport scrolling.
  * Ensures that scrolling remains within valid bounds.
  */
  const updateInput = () => {
    const scrollInfo = utilities.getVolumeViewportScrollInfo(viewAX, volumeId, false);

    if (scrollInfo.currentStepIndex < 0) {
      cornerstoneTools.utilities.scroll(viewAX, {delta:-1});
    }
    else if (scrollInfo.currentStepIndex > scrollInfo.numScrollSteps){
      cornerstoneTools.utilities.scroll(viewAX, {delta:1});
    }

    this.maxFrames = scrollInfo.numScrollSteps - 1;
    this.currentFrame = scrollInfo.currentStepIndex;

    this.$nextTick(() => {
      const slider = this.$refs.sliderContainer.querySelector('#frame-slider');
      slider.value = this.currentFrame;
    });

    input.value = utilities.getVolumeViewportScrollInfo(viewAX, volumeId, false).currentStepIndex;
  }

  elementAX.addEventListener(
    Enums.Events.CAMERA_MODIFIED,
    updateInput.bind(this)
  );

  //Define the slider
  const slider = this.$refs.sliderContainer.querySelector('#frame-slider');

  const onFrameSliderChange = () => {
    if (process.env.VUE_APP_DEBUG === "true") {
      console.log('Valor actual:', this.currentFrame);
    }

    const del = this.currentFrame - input.value;
    cornerstoneTools.utilities.scroll(viewAX, { delta: del });
    input.value = this.currentFrame;
  };
  
  slider.addEventListener('input', onFrameSliderChange);

  const outOfBonds = (evt) => {
    if (volLoaded) {
      const view = renderingEngine.getViewport(evt.detail.viewportId)
      const scrollInfo = utilities.getVolumeViewportScrollInfo(view, volumeId, false);
      if (scrollInfo.currentStepIndex < 0) {
        cornerstoneTools.utilities.scroll(view, {delta:-1});
      }
      else if (scrollInfo.currentStepIndex > scrollInfo.numScrollSteps){
        cornerstoneTools.utilities.scroll(view, {delta:1});
      }
    }
  };

  elementCO.addEventListener(
    Enums.Events.CAMERA_MODIFIED,
    outOfBonds
  );

  elementSA.addEventListener(
    Enums.Events.CAMERA_MODIFIED,
    outOfBonds
  );

  //Conseguimos el numero de versiones
  aux_api.fetchNumberOfVersions(viewAX, volume.metadata.FrameOfReferenceUID, annotationsJson, cornerstoneTools, stylesJson, true, segmentMapJsonLoaded);

  const isMobile = window.matchMedia('(any-pointer:coarse)').matches;


  //TODO Revisar rotacion

  //let getReferenceLineDraggableRotatable = function() {return false;};

  let getReferenceLineSlabThicknessControlsOn = function() {return false;};

  //let getReferenceLineControllable = function() {return false;};

  function getReferenceLineColor(viewportId) {
    return viewportColors[viewportId];
  }

  toolGroup.addTool(CrosshairsTool.toolName, {
    getReferenceLineColor,
    //getReferenceLineDraggableRotatable,
    getReferenceLineSlabThicknessControlsOn,
    //getReferenceLineControllable,
    mobile: {
      enabled: isMobile,
      opacity: 0.8,
      handleRadius: 9,
    },
  });



  toolGroup.setToolActive(CrosshairsTool.toolName, {
    bindings: [{ mouseButton: MouseBindings.Primary }],
  });
  

  //Dropwdow to changue classes
  setupAnnotationClassChangeDropdown(segmentMapJsonn, annotationsJson, stylesJson);

  viewAX.render();
  renderingEngine.renderViewports([viewportIdAX, viewportIdSA, viewportIdCO]);

} // End main function


/**
 * Function to initialize and configure Cornerstone tools.
 * 
 * This function performs the following:
 * 1. Registers necessary tools for image manipulation.
 * 2. Creates a tool group for organized tool management.
 * 3. Adds tools to the tool group with appropriate configurations.
 * 4. Defines tool activation settings and mouse button bindings.
 * 
 * @param {string} toolGroupId - The ID for the tool group.
 * @param {string} volumeId - The ID of the volume (if required).
 * @returns {object} The configured tool group.
 */
function setupCornerstoneTools(toolGroupId, volumeId) {

  // Register all necessary tools in Cornerstone
  cornerstoneTools.addTool(StackScrollMouseWheelTool);
  cornerstoneTools.addTool(CrosshairsTool);
  cornerstoneTools.addTool(PanTool);
  cornerstoneTools.addTool(ZoomTool);
  cornerstoneTools.addTool(SculptorTool);
  cornerstoneTools.addTool(PlanarFreehandROITool);
  cornerstoneTools.addTool(RectangleROITool);
  cornerstoneTools.addTool(ArrowAnnotateTool);

  // Create a tool group
  var toolGroup = ToolGroupManager.createToolGroup(toolGroupId);

  // Add tools to the tool group
  toolGroup.addTool(StackScrollMouseWheelTool.toolName);
  toolGroup.addTool(PanTool.toolName, { volumeId });
  toolGroup.addTool(ZoomTool.toolName, { volumeId });
  toolGroup.addTool(SculptorTool.toolName);
  toolGroup.addTool(PlanarFreehandROITool.toolName, { volumeId });
  toolGroup.addTool(RectangleROITool.toolName, { volumeId });
  toolGroup.addTool(ArrowAnnotateTool.toolName, { volumeId });


  // Configure tool activation settings
  // MouseBindings.Primary cubre click izquierdo (PC) + 1 dedo/stylus (tablet)
  toolGroup.setToolActive(PlanarFreehandROITool.toolName, {
    bindings: [
      {
        mouseButton: MouseBindings.Primary, // Left Click
      },
    ],
  });

  toolGroup.setToolActive(StackScrollMouseWheelTool.toolName);
  toolGroup.setToolActive(RectangleROITool.toolName);
  toolGroup.setToolActive(ArrowAnnotateTool.toolName);

  // Configure specific mouse button bindings for tools
  // Pan: click central (PC) + 3 dedos (tablet)
 toolGroup.setToolActive(PanTool.toolName, {
    bindings: [
      {
        mouseButton: MouseBindings.Auxiliary, // Middle Click
      },
      { 
        numTouchPoints: 3 
      }
    ],
  });

  // Zoom: click derecho (PC) + pellizco 2 dedos (tablet)
  toolGroup.setToolActive(ZoomTool.toolName, {
    bindings: [
      {
        mouseButton: MouseBindings.Secondary, // Right Click
      },
      { 
        numTouchPoints: 2 
      }
    ],
  });

  return toolGroup; // Return the configured tool group
}


/**
 * Function to create a viewport element.
 *
 * @param {string} id - The unique ID of the viewport.
 * @param {string} width - The width of the viewport (e.g., "60vw").
 * @param {string} height - The height of the viewport (e.g., "60vw").
 * @param {string} borderColor - Optional border color (default: none).
 * @returns {HTMLElement} The created viewport element.
 */
function createViewportElement(id, width, height, borderColor = null) {
  const element = document.createElement('div');
  element.id = id;
  element.oncontextmenu = () => false; // Disable right-click context menu
  element.style.width = width;
  element.style.height = height;
  element.style.backgroundColor = 'white'; 
  element.style.touchAction = 'none';         // PARA TABLET
  element.style.userSelect = 'none';          // PARA TABLET
  if (borderColor) {
    element.style.border = `2px solid ${borderColor}`;
  }
  return element;
}

/**
 * Function to set up event listeners for a viewport element.
 *
 * @param {HTMLElement} element - The viewport element.
 * @param {string} eventType - The type of event to listen for.
 * @param {Function} callback - The function to execute on event.
 */
function setupViewportEventListeners(element, eventType, callback) {
  element.addEventListener(eventType, callback);
}

/**
 * Function to create and configure the viewport layout.
 *
 * @returns {HTMLElement} The generated viewport grid.
 */
function setupViewportGrid(annotationsJson) {
  const content = document.getElementById('content');

  // Main viewport container
  const viewportGrid = document.createElement('div');
  viewportGrid.style.display = 'flex';
  viewportGrid.style.flexDirection = 'row';
  viewportGrid.style.height = '90vh';
  viewportGrid.style.width = '100%';

  // Secondary viewport container (for Sagittal & Coronal views)
  const viewportGrid2 = document.createElement('div');
  viewportGrid2.style.display = 'flex';
  viewportGrid2.style.flexDirection = 'column';
  viewportGrid2.style.height = '100%';
  viewportGrid2.style.width = '30vw';

  // Create viewport elements
  // AXIAL viewport (principal)
  const elementAX = createViewportElement('axialViewport');
  elementAX.style.flex = '1';
  //With zoom
  elementAX.style.width = '100vw'; 
  elementAX.style.height = '100vh';
  


  //Normal size
  //elementAX.style.height = '100%';
  //elementAX.style.width = '70vw'; 
  
  // SAGITTAL viewport (arriba derecha)
  const elementSA = createViewportElement('sagittalViewport');
  elementSA.style.flex = '1';
  elementSA.style.width = '30vw'; // o ajustable


  // CORONAL viewport (abajo derecha)
  const elementCO = createViewportElement('coronalViewport');
  elementCO.style.flex = '1';
  elementCO.style.width = '30vw'; // igual al sagittal


  // Add event listeners
  setupViewportEventListeners(elementAX, csToolsEnums.Events.KEY_DOWN, (evt) =>
    aux_cornestone.cancelDrawingEventListener(evt, cornerstoneTools, annotationsJson)
  );

  setupViewportEventListeners(elementAX, csToolsEnums.Events.MOUSE_CLICK, (evt) => {
    const mouseEvent = evt.detail.event;
  
    if (mouseEvent.button === 2) {  // Botón derecho
      console.log('🔥 Click DERECHO detectado');
    } else if (mouseEvent.button === 0) {  // Botón izquierdo
      console.log('🖱️ Click IZQUIERDO detectado');
    }
  });


  ['MOUSE_CLICK', 'MOUSE_UP', 'MOUSE_DOWN'].forEach((event) => {
    setupViewportEventListeners(elementSA, csToolsEnums.Events[event], (evt) =>
      aux_cornestone.cancelDrawingEvent(evt, cornerstoneTools)
    );
    setupViewportEventListeners(elementCO, csToolsEnums.Events[event], (evt) =>
      aux_cornestone.cancelDrawingEvent(evt, cornerstoneTools)
    );
  });

  // Assemble viewport layout
  viewportGrid.appendChild(elementAX);
  viewportGrid2.appendChild(elementSA);
  viewportGrid2.appendChild(elementCO);
  viewportGrid.appendChild(viewportGrid2);
  content.appendChild(viewportGrid);

  // Return viewport elements for later use
  return { elementAX, elementSA, elementCO };
}

/**
 * Function to initialize and configure viewports.
 *
 * @param {Object} renderingEngine - The rendering engine instance.
 * @param {Object} toolGroup - The tool group instance.
 * @param {string} renderingEngineId - The ID of the rendering engine.
 */
function initializeViewports(renderingEngine, toolGroup, renderingEngineId, viewportIdAX, viewportIdSA, viewportIdCO, elementAX, elementSA, elementCO) {
  // Configure viewport inputs
  const viewportInput = [
    {
      viewportId: viewportIdAX,
      element: elementAX,
      type: ViewportType.ORTHOGRAPHIC,
      defaultOptions: {
        orientation: Enums.OrientationAxis.AXIAL,
      },
    },
    {
      viewportId: viewportIdSA,
      element: elementSA,
      type: ViewportType.ORTHOGRAPHIC,
      defaultOptions: {
        orientation: Enums.OrientationAxis.SAGITTAL,
      },
    },
    {
      viewportId: viewportIdCO,
      element: elementCO,
      type: ViewportType.ORTHOGRAPHIC,
      defaultOptions: {
        orientation: Enums.OrientationAxis.CORONAL,
      },
    },
  ];

  // Set up the viewports in the rendering engine
  renderingEngine.setViewports(viewportInput);

  // Retrieve the axial viewport for further processing (if needed)
  const viewAX = renderingEngine.getViewport(viewportIdAX);

  // Assign tool group to viewports
  toolGroup.addViewport(viewportIdAX, renderingEngineId);
  toolGroup.addViewport(viewportIdCO, renderingEngineId);
  toolGroup.addViewport(viewportIdSA, renderingEngineId);

  return { viewAX };
}

/**
 * Sets up a dropdown menu to allow the user to change the annotation class
 * of a selected annotation. When the user selects a new class from the dropdown,
 * the annotation is moved to the corresponding annotation group and its style is updated.
 */
function setupAnnotationClassChangeDropdown(segmentMapJsonn, annotationsJson, stylesJson) {

  // Get the container for the dropdown and clear any existing content
  const dropdownContainer = document.getElementById("changueClassContainer");
  dropdownContainer.innerHTML = '';
  
  dropdownContainer.style.display = 'flex';
  dropdownContainer.style.flexDirection = 'column';
  dropdownContainer.style.alignItems = 'start'; // Puedes usar 'center' si quieres centrado horizontalmente
  dropdownContainer.style.gap = '5px'; // Espacio entre label y dropdown
  dropdownContainer.style.marginBottom='5px'

  // Create a label describing the functionality
  const label = document.createElement('label');
  label.textContent = 'Change selected annotation class: ';
  label.setAttribute('for', 'annotation-class-change-dropdown');
  label.style.marginRight = '10px';

  const dropdown = document.createElement('select');
  dropdown.id = 'annotation-class-change-dropdown';

  // Add options based on `segmentMapJsonn`
  for (const [className, classId] of segmentMapJsonn.entries()) {
    const option = document.createElement('option');
    option.value = classId; // El ID de la clase
    option.textContent = className; // El nombre mostrado
    dropdown.appendChild(option);
  }

  // Append label and dropdown to the container
  dropdownContainer.appendChild(label);
  dropdownContainer.appendChild(dropdown);

  // Event when changing the selected annotation class
  dropdown.addEventListener('change', (event) => {
    const selectedClassId = parseInt(event.target.value);

    // Get the currently selected annotation
    const selectedAnnotationUID = cornerstoneTools.annotation.selection.getAnnotationsSelected()[0];

    if (!selectedAnnotationUID) {
      alert("Annotation not found.");
      return;
    }

    // Retrieve the annotation object
    const annotation = cornerstoneTools.annotation.state.getAnnotation(selectedAnnotationUID);

    if (!annotation) {
      alert("No annotation selected.");
      return;
    }

    // Remove it from its previous group
    for (let i = 0; i < annotationsJson.length; i++) {
      annotationsJson[i].remove(annotation.annotationUID);
    }

    // Add it to the new group
    annotationsJson[selectedClassId - 1].add(annotation.annotationUID);

    if (process.env.VUE_APP_DEBUG === "true") {
      console.log(` Annotation ${annotation.annotationUID} moved to class ID ${selectedClassId}`);
    }
    // change its color or style
    cornerstoneTools.annotation.config.style.setAnnotationStyles(annotation.annotationUID, stylesJson[selectedClassId - 1]);

    console.log("Actualizando las anotaciones activas");
    // Update currently visible annotations
    aux_cornestone.updateActiveAnnotation(all, annotationsJson, activeSegmentIndex);

  });
}
